import { Component, Input, OnInit, forwardRef } from '@angular/core';
import { ControlValueAccessor, FormBuilder, FormControl, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseDataObject } from '../../facilities-form.domain';
import { AllDropdownKeys } from '../../../../jurisdiction/jurisdiction.constants';
import { CommonService } from '../../../../services/common.service';

@Component({
  selector: 'app-water-system-components',
  templateUrl: './water-system-components.component.html',
  styleUrls: ['./water-system-components.component.scss'],
})
export class WaterSystemComponentsComponent {
  @Input() form: FormGroup;
  @Input() isReadOnly: boolean = false;

  waterFormOptions = {
    pipeMaterialOptions: this.commonService.getDropdownData(AllDropdownKeys.WaterPipeMaterial),
    installationTypeOptions: this.commonService.getDropdownData(AllDropdownKeys.WaterInstallationType),
    refluxFuseOptions: this.commonService.getDropdownData(AllDropdownKeys.WaterRefluxFuse),
    devicesOptions: this.commonService.getDropdownData(AllDropdownKeys.WaterDevices),
  };

  constructor(private commonService: CommonService) {}
}
